// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BASIC */
.Login {
  background-color: white;
}

.banner {
  margin-top: 200px;
}

html {
  background-color: #56baed;
}

body {
  font-family: "Poppins", sans-serif;
  height: 100vh;
}

a {
  color: #92badd;
  display: inline-block;
  text-decoration: none;
  font-weight: 400;
}

h2 {
  text-align: center;
  font-size: 20px !important;
  font-weight: 600;
  text-transform: uppercase;
  display: inline-block;
  color: #cccccc;
}

/* STRUCTURE */
.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 20px;
}

#formContent {
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 30px;
  width: 100%;
  max-width: 450px;
  position: relative;
  padding: 0px;
  box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  text-align: center;
  border: 0.5px solid lightgrey;
}
#formContent p {
  padding: 0px 10px;
  justify-content: flex-start !important;
  font-size: 16px !important;
}
#formContent span {
  text-align: left !important;
}

.btn {
  background: #5ea1d8 !important;
}

#formFooter {
  background-color: #f6f6f6;
  border-top: 1px solid #dce8f1;
  padding: 25px;
  text-align: center;
  border-radius: 0 0 10px 10px;
}

/* TABS */
h2.inactive {
  color: #cccccc;
}

h2.active {
  color: #0d0d0d;
  border-bottom: 2px solid #5fbae9;
}

/* FORM TYPOGRAPHY*/
input[type=button],
input[type=submit],
input[type=reset] {
  background-color: #56baed;
  border: none;
  color: white;
  padding: 15px 80px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  text-transform: uppercase;
  font-size: 13px;
  box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
  border-radius: 5px 5px 5px 5px;
  margin: 5px 20px 40px 20px;
  transition: all 0.3s ease-in-out;
}

input[type=button]:hover,
input[type=submit]:hover,
input[type=reset]:hover {
  background-color: #39ace7;
}

input[type=button]:active,
input[type=submit]:active,
input[type=reset]:active {
  transform: scale(0.95);
}

input[type=text],
input[type=password] {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  transition: all 0.5s ease-in-out;
  border-radius: 5px 5px 5px 5px;
}

input[type=text]:focus,
input[type=password]:focus {
  background-color: #fff;
  border-bottom: 2px solid #5fbae9;
}

input[type=text]:placeholder,
input[type=password] {
  color: #cccccc;
}

/* ANIMATIONS */
/* Simple CSS3 Fade-in-down Animation */
.fadeInDown {
  animation-name: fadeInDown;
  animation-duration: 1s;
  animation-fill-mode: both;
}
@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}
/* Simple CSS3 Fade-in Animation */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.fadeIn {
  opacity: 0;
  animation: fadeIn ease-in 1;
  animation-fill-mode: forwards;
  animation-duration: 1s;
}

.fadeIn.first {
  animation-delay: 0.4s;
}

.fadeIn.second {
  animation-delay: 0.6s;
  border: 0.5px solid lightgrey;
}

.fadeIn.third {
  animation-delay: 0.8s;
  border: 0.5px solid lightgrey;
}

.fadeIn.fourth {
  animation-delay: 1s;
  border: 0.5px solid lightgrey;
}

/* Simple CSS3 Fade-in Animation */
.underlineHover:after {
  display: block;
  left: 0;
  bottom: -10px;
  width: 0;
  height: 2px;
  background-color: #56baed;
  content: "";
  transition: width 0.2s;
}

.underlineHover:hover {
  color: #0d0d0d;
}

.underlineHover:hover:after {
  width: 100%;
}

/* OTHERS */
*:focus {
  outline: none;
}

#icon {
  width: 60%;
}

.mat-badge-content {
  background: #5ea1d8;
}

.radiobtn-group div {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.radiobtn-group div > :first-child {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 10px;
}
.radiobtn-group .in-textarea-wrap {
  display: block;
  width: 100%;
  padding: 0px 10px;
}
.radiobtn-group .in-textarea-wrap textarea {
  width: 100%;
}

.container {
  padding: 0px !important;
  max-height: 90vh;
  overflow-y: auto;
}

.box {
  max-width: 360px;
  width: 100% !important;
  margin: 10px;
  padding: 0px 25px;
  background: #fff;
  background-size: 50%;
  background-position: top center;
  position: relative;
  display: flex;
  flex-direction: column;
  box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15);
  overflow: hidden;
  background: "https://flowchest-cdn.azureedge.net/mediaimage/Screenshot 2023-05-05 1448027cea2b039f4a4049a42ef2bcf6c81c54.png";
  background-size: cover;
  background-position: center;
  border-radius: 15px 15px 0px 0px;
  margin: 0px auto;
  background-repeat: no-repeat !important;
  background-size: contain !important;
  background-size: 100% 90%;
  background-position: top center;
}

.container .box {
  width: 100%;
  min-height: 250px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 8px;
}

.box-wrap {
  position: relative;
  z-index: 2;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 30px 0px;
  display: flex;
  flex-wrap: wrap;
}

.box:after {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
  background: rgba(0, 0, 0, 0.5);
}

.with-icon {
  text-align: left;
  height: 35px !important;
}
.with-icon img {
  margin: 0px !important;
}

.des-box {
  background: #fff;
  position: relative;
  width: 100%;
  background: #fff;
  position: relative;
}
.des-box > div > div mat-card {
  background: #f3f1f1 !important;
  background: #fff !important;
}
.des-box i {
  color: #212427 !important;
}

.des-box:after {
  content: "";
  width: 200%;
  height: 150vh;
  background: #fff;
  border-radius: 0px;
  position: absolute;
  top: 0px;
  z-index: -1;
  left: -50%;
  right: -50%;
}

.des-box:before {
  content: "";
  width: 200%;
  height: 40vh;
  background: #fff;
  border-radius: 100% 100% 0px 0px;
  position: absolute;
  top: -34px;
  z-index: -1;
  left: -50%;
  right: -50%;
}

.title-box {
  padding: 0px 0px 60px 0px;
  width: 100%;
}

.title-box-meta {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 8px;
}

.title-box-price {
  position: relative;
}

.priceIcon-p {
  top: unset !important;
  bottom: 20px !important;
}

.title-div {
  border-bottom: 1px solid gray;
}

.title-box h2 {
  color: #fff !important;
  font-size: 18px;
  font-weight: normal;
  margin-bottom: 20px;
  text-align: left;
  text-transform: unset !important;
}

.title-box ul {
  margin: 0px;
  padding: 0px;
}

.title-box ul li {
  color: #fff;
  list-style: none;
  padding: 8px 10px 8px 0px;
  font-size: 16px;
  text-align: left;
}

.title-box ul li span {
  margin-right: 8px;
}

.footer-div {
  border-top: 1px solid gray;
  display: flex;
  justify-content: space-between;
}

.footer-div p {
  margin-top: 10px;
  margin-bottom: 0px;
}

p,
h5 {
  color: #212427 !important;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

h5 {
  font-size: 16px;
  font-weight: bold;
  margin-top: 0px;
  margin-bottom: 10px;
}

.close-ico {
  position: absolute;
  top: 12px;
  right: 12px;
  color: #ffffff;
  opacity: 1 !important;
  z-index: 10;
  cursor: pointer;
}

.close-ico .close-icon {
  font-size: 24px;
}

.code-div {
  height: 200px;
  overflow-y: scroll;
}

.input-container {
  position: relative;
  display: flex;
  height: 2.8rem;
  width: 100%;
  background-color: #fff;
  border-radius: 8px;
  margin-top: 10px;
  box-shadow: 20px 20px 30px rgba(0, 0, 0, 0.05);
}

.input-container input {
  height: 100%;
  width: 100%;
  border-radius: 8px;
  border: 1px solid rgb(176, 190, 197);
  background-color: transparent;
  padding: 0.625rem 70px 0.625rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  color: rgb(69, 90, 100);
  outline: none;
  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
}

.invite-btn {
  position: absolute;
  cursor: pointer;
  right: 4px;
  top: 4px;
  bottom: 4px;
  z-index: 10;
  border-radius: 4px;
  background-color: #5ea1d8;
  color: white;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  text-align: center;
  vertical-align: middle;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  border: none;
}

.invite-btn:hover {
  right: 2px;
  top: 2px;
  bottom: 2px;
  border-radius: 8px;
}

.input-container input:placeholder-shown ~ .invite-btn {
  pointer-events: none;
  background-color: #5ea1d8;
  opacity: 0.5;
}

form {
  display: flex;
  align-items: center;
}
form input {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  transition: all 0.5s ease-in-out;
  border-radius: 5px;
  outline: none !important;
  border: 0.5px solid lightgrey;
}

.parent-comment-box {
  background: #f3f1f1 !important;
  padding: 10px;
  max-height: 400px;
  overflow-y: scroll;
}

.des-box > div > div mat-card.mat-mdc-card.mdc-card.example-card.child-comment {
  background: #f8f8f8 !important;
  margin-left: 40px;
  margin-top: 10px;
}
.des-box > div > div mat-card.mat-mdc-card.mdc-card.example-card.child-comment mat-card {
  padding: 10px;
}

@media (max-width: 767px) {
  p {
    flex-wrap: wrap;
  }
}
span.mdc-list-item__content {
  text-align: left !important;
}

button {
  font-family: "Raleway";
  background-color: #5ea1d8;
  font-size: 15px;
  cursor: pointer;
  color: white;
  padding: 10px;
  border-radius: 10px;
  border: none;
}

.report-dialog-heading-wrap {
  margin-left: 20px;
}

.report-dialog-section-title {
  color: #212427;
  font-size: 20px;
  font-weight: bold;
  margin-top: -10px;
  margin-bottom: 4px;
  text-align: center;
}

.report-dialog-subtitle {
  color: #212427;
  font-size: 14px;
  margin: 0 0 12px;
  text-align: left;
}

p.report-dialog-section-title,
p.report-dialog-subtitle {
  display: block !important;
  justify-content: unset !important;
  align-items: unset !important;
}

.des-box .report-dialog-form#formContent {
  box-shadow: none !important;
  border: none !important;
  background: transparent !important;
  text-align: left;
  max-width: none;
  width: 100%;
  padding: 0 8px 16px;
}

.des-box .report-dialog-footer#formFooter {
  background: transparent !important;
  border-top: 1px solid #e4e8f0;
  padding: 16px 0 8px;
  margin-top: 8px;
  border-radius: 0;
}

.report-dialog-submit {
  width: 120px;
  font-size: 16px;
  background-color: #5ea1d8 !important;
  color: #fff !important;
}

.report-dialog-submit:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

:host-context(body.theme-dark) {
  /* Radio button circles */
}
:host-context(body.theme-dark) .box,
:host-context(body.theme-dark) .des-box,
:host-context(body.theme-dark) .des-box:before,
:host-context(body.theme-dark) .des-box:after,
:host-context(body.theme-dark) .report-dialog-form#formContent,
:host-context(body.theme-dark) .report-dialog-footer#formFooter {
  background: #111827 !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) p,
:host-context(body.theme-dark) h5,
:host-context(body.theme-dark) span,
:host-context(body.theme-dark) label,
:host-context(body.theme-dark) small,
:host-context(body.theme-dark) .report-dialog-section-title,
:host-context(body.theme-dark) .report-dialog-subtitle,
:host-context(body.theme-dark) .close-ico,
:host-context(body.theme-dark) .close-ico .close-icon {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) textarea,
:host-context(body.theme-dark) input,
:host-context(body.theme-dark) .in-textarea-wrap textarea {
  background: #1f2937 !important;
  color: #f8fafc !important;
  border-color: rgba(148, 163, 184, 0.45) !important;
}
:host-context(body.theme-dark) ::ng-deep .mdc-radio__outer-circle {
  border-color: #94a3b8 !important;
}
:host-context(body.theme-dark) ::ng-deep .mdc-radio--checked .mdc-radio__outer-circle,
:host-context(body.theme-dark) ::ng-deep .mat-mdc-radio-checked .mdc-radio__outer-circle {
  border-color: #ffffff !important;
}
:host-context(body.theme-dark) ::ng-deep .mdc-radio--checked .mdc-radio__inner-circle,
:host-context(body.theme-dark) ::ng-deep .mat-mdc-radio-checked .mdc-radio__inner-circle {
  border-color: #ffffff !important;
}
:host-context(body.theme-dark) ::ng-deep .mat-mdc-radio-button .mdc-radio .mdc-radio__native-control:enabled:checked + .mdc-radio__background .mdc-radio__outer-circle {
  border-color: #ffffff !important;
}
:host-context(body.theme-dark) ::ng-deep .mat-mdc-radio-button .mdc-radio .mdc-radio__native-control:enabled:checked + .mdc-radio__background .mdc-radio__inner-circle {
  border-color: #ffffff !important;
}
:host-context(body.theme-dark) ::ng-deep .mat-mdc-radio-button .mdc-radio .mdc-radio__native-control:enabled:not(:checked) + .mdc-radio__background .mdc-radio__outer-circle {
  border-color: #94a3b8 !important;
}
:host-context(body.theme-dark) ::ng-deep .mat-mdc-radio-button .mat-ripple-element {
  background-color: rgba(255, 255, 255, 0.12) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/report-bundle/report-bundle.component.scss"],"names":[],"mappings":"AAAA,UAAA;AAEA;EACE,uBAAA;AAAF;;AAEA;EACE,iBAAA;AACF;;AACA;EACE,yBAAA;AAEF;;AACA;EACE,kCAAA;EACA,aAAA;AAEF;;AACA;EACE,cAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;AAEF;;AACA;EACE,kBAAA;EACA,0BAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EAEA,cAAA;AACF;;AAEA,cAAA;AAEA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;AAAF;;AAGA;EAEE,kCAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EAEA,4CAAA;EACA,kBAAA;EACA,6BAAA;AAAF;AAGA;EACE,iBAAA;EACA,sCAAA;EACA,0BAAA;AADF;AAGA;EACE,2BAAA;AADF;;AAIA;EACE,8BAAA;AADF;;AAIA;EACE,yBAAA;EACA,6BAAA;EACA,aAAA;EACA,kBAAA;EAEA,4BAAA;AADF;;AAIA,SAAA;AAEA;EACE,cAAA;AAFF;;AAKA;EACE,cAAA;EACA,gCAAA;AAFF;;AAKA,mBAAA;AAEA;;;EAGE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;EAEA,iDAAA;EAEA,8BAAA;EACA,0BAAA;EAKA,gCAAA;AAHF;;AAMA;;;EAGE,yBAAA;AAHF;;AAMA;;;EAOE,sBAAA;AAHF;;AAMA;;EAEE,yBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EAKA,gCAAA;EAEA,8BAAA;AAHF;;AAMA;;EAEE,sBAAA;EACA,gCAAA;AAHF;;AAMA;;EAEE,cAAA;AAHF;;AAMA,eAAA;AAEA,uCAAA;AACA;EAEE,0BAAA;EAEA,sBAAA;EAEA,yBAAA;AAJF;AAoBA;EACE;IACE,UAAA;IAEA,mCAAA;EALF;EAOA;IACE,UAAA;IAEA,eAAA;EALF;AACF;AAQA,kCAAA;AAiBA;EACE;IACE,UAAA;EANF;EAQA;IACE,UAAA;EANF;AACF;AASA;EACE,UAAA;EAGA,2BAAA;EAIA,6BAAA;EAIA,sBAAA;AATF;;AAYA;EAGE,qBAAA;AATF;;AAYA;EAGE,qBAAA;EACA,6BAAA;AATF;;AAYA;EAGE,qBAAA;EACA,6BAAA;AATF;;AAYA;EAGE,mBAAA;EACA,6BAAA;AATF;;AAYA,kCAAA;AACA;EACE,cAAA;EACA,OAAA;EACA,aAAA;EACA,QAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;EACA,sBAAA;AATF;;AAYA;EACE,cAAA;AATF;;AAYA;EACE,WAAA;AATF;;AAYA,WAAA;AAEA;EACE,aAAA;AAVF;;AAaA;EACE,UAAA;AAVF;;AAYA;EACE,mBAAA;AATF;;AAYE;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;AATJ;AAUI;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;AARN;AAWE;EACE,cAAA;EACA,WAAA;EACA,iBAAA;AATJ;AAUI;EACE,WAAA;AARN;;AAeA;EACE,uBAAA;EACA,gBAAA;EACA,gBAAA;AAZF;;AAcA;EACE,gBAAA;EACA,sBAAA;EAGA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,+BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8EAAA;EACA,gBAAA;EACA,6HAAA;EACA,sBAAA;EACA,2BAAA;EACA,gCAAA;EACA,gBAAA;EACA,uCAAA;EACA,mCAAA;EACA,yBAAA;EACA,+BAAA;AAbF;;AAgBA;EACE,WAAA;EACA,iBAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EACA,kBAAA;AAbF;;AAgBA;EACE,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;AAbF;;AAeA;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,8BAAA;AAZF;;AAcA;EACE,gBAAA;EACA,uBAAA;AAXF;AAYE;EACE,sBAAA;AAVJ;;AAcA;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AAXF;AAkBM;EACE,8BAAA;EACA,2BAAA;AAhBR;AAoBE;EACE,yBAAA;AAlBJ;;AAqBA;EACE,WAAA;EACA,WAAA;EACA,aAAA;EAEA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;AAnBF;;AAqBA;EACE,WAAA;EACA,WAAA;EACA,YAAA;EAEA,gBAAA;EACA,gCAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;AAnBF;;AAsBA;EACE,yBAAA;EACA,WAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,eAAA;EACA,QAAA;AAnBF;;AAsBA;EACE,kBAAA;AAnBF;;AAsBA;EACE,qBAAA;EACA,uBAAA;AAnBF;;AAqBA;EACE,6BAAA;AAlBF;;AAoBA;EACE,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gCAAA;AAjBF;;AAmBA;EACE,WAAA;EACA,YAAA;AAhBF;;AAkBA;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;AAfF;;AAiBA;EACE,iBAAA;AAdF;;AAiBA;EACE,0BAAA;EACA,aAAA;EACA,8BAAA;AAdF;;AAgBA;EACE,gBAAA;EACA,kBAAA;AAbF;;AAgBA;;EAEE,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAbF;;AAeA;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AAZF;;AAcA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;AAXF;;AAcA;EACE,eAAA;AAXF;;AAcA;EACE,aAAA;EACA,kBAAA;AAXF;;AAcA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;EAGA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AAbF;;AAgBA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,6BAAA;EACA,uCAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,kDAAA;AAbF;;AAoBA;EACE,kBAAA;EACA,eAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,oBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;AAjBF;;AAqBA;EACE,UAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;AAlBF;;AAqBA;EACE,oBAAA;EACA,yBAAA;EACA,YAAA;AAlBF;;AAoBA;EACE,aAAA;EACA,mBAAA;AAjBF;AAkBE;EACE,yBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,gCAAA;EACA,kBAAA;EACA,wBAAA;EACA,6BAAA;AAhBJ;;AAmBA;EACA,8BAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;AAhBA;;AAkBA;EACE,8BAAA;EACA,iBAAA;EACA,gBAAA;AAfF;AAgBE;EACE,aAAA;AAdJ;;AAiBA;EACE;IACE,eAAA;EAdF;AACF;AAuBA;EACE,2BAAA;AArBF;;AAuBA;EACE,sBAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AApBF;;AAuBA;EACE,iBAAA;AApBF;;AAuBA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AApBF;;AAuBA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AApBF;;AAuBA;;EAEE,yBAAA;EACA,iCAAA;EACA,6BAAA;AApBF;;AAuBA;EACE,2BAAA;EACA,uBAAA;EACA,kCAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;AApBF;;AAuBA;EACE,kCAAA;EACA,6BAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AApBF;;AAuBA;EACE,YAAA;EACA,eAAA;EACA,oCAAA;EACA,sBAAA;AApBF;;AAuBA;EACE,YAAA;EACA,mBAAA;AApBF;;AAuBA;EAgCE,yBAAA;AAnDF;AAoBE;;;;;;EAME,8BAAA;EACA,yBAAA;EACA,iDAAA;AAlBJ;AAqBE;;;;;;;;;EASE,yBAAA;AAnBJ;AAsBE;;;EAGE,8BAAA;EACA,yBAAA;EACA,kDAAA;AApBJ;AAwBE;EACE,gCAAA;AAtBJ;AAyBE;;EAEE,gCAAA;AAvBJ;AA0BE;;EAEE,gCAAA;AAxBJ;AA2BE;EAEE,gCAAA;AA1BJ;AA6BE;EAEE,gCAAA;AA5BJ;AA+BE;EAEE,gCAAA;AA9BJ;AAiCE;EACE,sDAAA;AA/BJ","sourcesContent":["/* BASIC */\n\n.Login {\n  background-color: white;\n}\n.banner {\n  margin-top: 200px;\n}\nhtml {\n  background-color: #56baed;\n}\n\nbody {\n  font-family: \"Poppins\", sans-serif;\n  height: 100vh;\n}\n\na {\n  color: #92badd;\n  display: inline-block;\n  text-decoration: none;\n  font-weight: 400;\n}\n\nh2 {\n  text-align: center;\n  font-size: 20px !important;\n  font-weight: 600;\n  text-transform: uppercase;\n  display: inline-block;\n // margin: 40px 8px 10px 8px;\n  color: #cccccc;\n}\n\n/* STRUCTURE */\n\n.wrapper {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  width: 100%;\n  min-height: 100%;\n  padding: 20px;\n}\n\n#formContent {\n  -webkit-border-radius: 10px 10px 10px 10px;\n  border-radius: 10px 10px 10px 10px;\n  background: #fff;\n  padding: 30px;\n  width: 100%;\n  max-width: 450px;\n  position: relative;\n  padding: 0px;\n  -webkit-box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);\n  box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);\n  text-align: center;\n  border: 0.5px solid lightgrey;\n  // max-height:200px;\n  // overflow-y: scroll;\np{\n  padding: 0px 10px;\n  justify-content: flex-start !important;\n  font-size: 16px !important;\n}\nspan{\n  text-align: left !important;\n}\n}\n.btn{\n  background:#5ea1d8 !important;\n}\n\n#formFooter {\n  background-color: #f6f6f6;\n  border-top: 1px solid #dce8f1;\n  padding: 25px;\n  text-align: center;\n  -webkit-border-radius: 0 0 10px 10px;\n  border-radius: 0 0 10px 10px;\n}\n\n/* TABS */\n\nh2.inactive {\n  color: #cccccc;\n}\n\nh2.active {\n  color: #0d0d0d;\n  border-bottom: 2px solid #5fbae9;\n}\n\n/* FORM TYPOGRAPHY*/\n\ninput[type=\"button\"],\ninput[type=\"submit\"],\ninput[type=\"reset\"] {\n  background-color: #56baed;\n  border: none;\n  color: white;\n  padding: 15px 80px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  text-transform: uppercase;\n  font-size: 13px;\n  -webkit-box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);\n  box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);\n  -webkit-border-radius: 5px 5px 5px 5px;\n  border-radius: 5px 5px 5px 5px;\n  margin: 5px 20px 40px 20px;\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n}\n\ninput[type=\"button\"]:hover,\ninput[type=\"submit\"]:hover,\ninput[type=\"reset\"]:hover {\n  background-color: #39ace7;\n}\n\ninput[type=\"button\"]:active,\ninput[type=\"submit\"]:active,\ninput[type=\"reset\"]:active {\n  -moz-transform: scale(0.95);\n  -webkit-transform: scale(0.95);\n  -o-transform: scale(0.95);\n  -ms-transform: scale(0.95);\n  transform: scale(0.95);\n}\n\ninput[type=\"text\"],\ninput[type=\"password\"] {\n  background-color: #f6f6f6;\n  border: none;\n  color: #0d0d0d;\n  padding: 15px 32px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 16px;\n  margin: 5px;\n  width: 85%;\n  border: 2px solid #f6f6f6;\n  -webkit-transition: all 0.5s ease-in-out;\n  -moz-transition: all 0.5s ease-in-out;\n  -ms-transition: all 0.5s ease-in-out;\n  -o-transition: all 0.5s ease-in-out;\n  transition: all 0.5s ease-in-out;\n  -webkit-border-radius: 5px 5px 5px 5px;\n  border-radius: 5px 5px 5px 5px;\n}\n\ninput[type=\"text\"]:focus,\ninput[type=\"password\"]:focus {\n  background-color: #fff;\n  border-bottom: 2px solid #5fbae9;\n}\n\ninput[type=\"text\"]:placeholder,\ninput[type=\"password\"] {\n  color: #cccccc;\n}\n\n/* ANIMATIONS */\n\n/* Simple CSS3 Fade-in-down Animation */\n.fadeInDown {\n  -webkit-animation-name: fadeInDown;\n  animation-name: fadeInDown;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@-webkit-keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n/* Simple CSS3 Fade-in Animation */\n@-webkit-keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@-moz-keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.fadeIn {\n  opacity: 0;\n  -webkit-animation: fadeIn ease-in 1;\n  -moz-animation: fadeIn ease-in 1;\n  animation: fadeIn ease-in 1;\n\n  -webkit-animation-fill-mode: forwards;\n  -moz-animation-fill-mode: forwards;\n  animation-fill-mode: forwards;\n\n  -webkit-animation-duration: 1s;\n  -moz-animation-duration: 1s;\n  animation-duration: 1s;\n}\n\n.fadeIn.first {\n  -webkit-animation-delay: 0.4s;\n  -moz-animation-delay: 0.4s;\n  animation-delay: 0.4s;\n}\n\n.fadeIn.second {\n  -webkit-animation-delay: 0.6s;\n  -moz-animation-delay: 0.6s;\n  animation-delay: 0.6s;\n  border: 0.5px solid lightgrey;\n}\n\n.fadeIn.third {\n  -webkit-animation-delay: 0.8s;\n  -moz-animation-delay: 0.8s;\n  animation-delay: 0.8s;\n  border: 0.5px solid lightgrey;\n}\n\n.fadeIn.fourth {\n  -webkit-animation-delay: 1s;\n  -moz-animation-delay: 1s;\n  animation-delay: 1s;\n  border: 0.5px solid lightgrey;\n}\n\n/* Simple CSS3 Fade-in Animation */\n.underlineHover:after {\n  display: block;\n  left: 0;\n  bottom: -10px;\n  width: 0;\n  height: 2px;\n  background-color: #56baed;\n  content: \"\";\n  transition: width 0.2s;\n}\n\n.underlineHover:hover {\n  color: #0d0d0d;\n}\n\n.underlineHover:hover:after {\n  width: 100%;\n}\n\n/* OTHERS */\n\n*:focus {\n  outline: none;\n}\n\n#icon {\n  width: 60%;\n}\n.mat-badge-content {\n  background: #5ea1d8;\n}\n.radiobtn-group {\n  div {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n    & > :first-child {\n      flex: 1;\n      display: flex;\n      align-items: center;\n      justify-content: flex-start;\n      padding: 0px 10px;\n    }\n  }\n  .in-textarea-wrap {\n    display: block;\n    width: 100%;\n    padding: 0px 10px;\n    textarea {\n      width: 100%;\n    }\n  }\n}\n\n\n\n.container {\n  padding: 0px !important;\n  max-height:90vh;\n  overflow-y: auto;\n}\n.box {\n  max-width: 360px;\n  width:100% !important;\n  // max-height:90vh;\n  // min-height:77vh !important;\n  margin: 10px;\n  padding: 0px 25px;\n  background: #fff;\n  background-size: 50%;\n  background-position: top center;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 5px 11px 0 rgb(0 0 0 / 18%), 0 4px 15px 0 rgb(0 0 0 / 15%);\n  overflow: hidden;\n  background: \"https://flowchest-cdn.azureedge.net/mediaimage/Screenshot 2023-05-05 1448027cea2b039f4a4049a42ef2bcf6c81c54.png\";\n  background-size: cover;\n  background-position: center;\n  border-radius: 15px 15px 0px 0px;\n  margin: 0px auto;\n  background-repeat: no-repeat !important;\n  background-size: contain !important;\n  background-size: 100% 90%;\n  background-position: top center;\n}\n\n.container .box {\n  width: 100%;\n  min-height: 250px;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  border-radius: 8px;\n}\n\n.box-wrap {\n  position: relative;\n  z-index: 2;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  padding: 30px 0px;\n  display: flex;\n  flex-wrap: wrap;\n}\n.box:after {\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  z-index: 1;\n  background: rgba(0, 0, 0, 0.5);\n}\n.with-icon {\n  text-align: left;\n  height:35px !important;\n  img{\n    margin: 0px !important;\n  }\n}\n\n.des-box {\n  background: #fff;\n  position: relative;\n  width: 100%;\n  background: #fff;\n  position: relative;\n  // height: 300px;\n  // overflow-y: scroll;\n  // overflow-x: hidden;\n  // word-break: break-all;\n  & > div {\n    & > div {\n      mat-card {\n        background: #f3f1f1 !important;\n        background: #fff !important;\n      }\n    }\n  }\n  i {\n    color: #212427 !important;\n  }\n}\n.des-box:after {\n  content: \"\";\n  width: 200%;\n  height: 150vh;\n  // height:-webkit-fill-available;\n  background: #fff;\n  border-radius: 0px;\n  position: absolute;\n  top: 0px;\n  z-index: -1;\n  left: -50%;\n  right: -50%;\n}\n.des-box:before {\n  content: \"\";\n  width: 200%;\n  height: 40vh;\n  // height:-webkit-fill-available;\n  background: #fff;\n  border-radius: 100% 100% 0px 0px;\n  position: absolute;\n  top: -34px;\n  z-index: -1;\n  left: -50%;\n  right: -50%;\n}\n\n.title-box {\n  padding: 0px 0px 60px 0px;\n  width: 100%;\n}\n\n.title-box-meta {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.title-box-price {\n  position: relative;\n}\n\n.priceIcon-p {\n  top: unset !important;\n  bottom: 20px !important;\n}\n.title-div {\n  border-bottom: 1px solid gray;\n}\n.title-box h2 {\n  color: #fff !important;\n  font-size: 18px;\n  font-weight: normal;\n  margin-bottom: 20px;\n  text-align: left;\n  text-transform: unset !important;\n}\n.title-box ul {\n  margin: 0px;\n  padding: 0px;\n}\n.title-box ul li {\n  color: #fff;\n  list-style: none;\n  padding: 8px 10px 8px 0px;\n  font-size: 16px;\n  text-align: left;\n}\n.title-box ul li span {\n  margin-right: 8px;\n}\n\n.footer-div {\n  border-top: 1px solid gray;\n  display: flex;\n  justify-content: space-between;\n}\n.footer-div p {\n  margin-top: 10px;\n  margin-bottom: 0px;\n}\n\np,\nh5 {\n  color: #212427 !important;\n  text-align: left;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\nh5 {\n  font-size: 16px;\n  font-weight: bold;\n  margin-top: 0px;\n  margin-bottom: 10px;\n}\n.close-ico {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  color: #ffffff;\n  opacity: 1 !important;\n  z-index: 10;\n  cursor: pointer;\n}\n\n.close-ico .close-icon {\n  font-size: 24px;\n}\n\n.code-div {\n  height: 200px;\n  overflow-y: scroll;\n}\n\n.input-container {\n  position: relative;\n  display: flex;\n  height: 2.8rem;\n  width: 100%;\n  // min-width: 200px;\n  // max-width: 250px;\n  background-color: #fff;\n  border-radius: 8px;\n  margin-top: 10px;\n  box-shadow: 20px 20px 30px rgba(0, 0, 0, 0.05);\n}\n\n.input-container input {\n  height: 100%;\n  width: 100%;\n  border-radius: 8px;\n  border: 1px solid rgb(176 190 197);\n  background-color: transparent;\n  padding: 0.625rem 70px 0.625rem 0.75rem;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  font-weight: 400;\n  color: rgb(69 90 100);\n  outline: none;\n  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.input-container input:focus {\n  // border: 1px solid rgb(236 72 153 );\n}\n\n.invite-btn {\n  position: absolute;\n  cursor: pointer;\n  right: 4px;\n  top: 4px;\n  bottom: 4px;\n  z-index: 10;\n  border-radius: 4px;\n  background-color: #5ea1d8;\n  color: white;\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  text-align: center;\n  vertical-align: middle;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  border: none;\n  // transition: .6s ease;\n}\n\n.invite-btn:hover {\n  right: 2px;\n  top: 2px;\n  bottom: 2px;\n  border-radius: 8px;\n}\n\n.input-container input:placeholder-shown ~ .invite-btn {\n  pointer-events: none;\n  background-color: #5ea1d8;\n  opacity: 0.5;\n}\nform {\n  display: flex;\n  align-items: center;\n  input {\n    background-color: #f6f6f6;\n    border: none;\n    color: #0d0d0d;\n    padding: 15px 32px;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 16px;\n    margin: 5px;\n    width: 85%;\n    border: 2px solid #f6f6f6;\n    transition: all 0.5s ease-in-out;\n    border-radius: 5px;\n    outline:none !important;\n    border:.5px solid lightgrey;\n  }\n}\n.parent-comment-box{\nbackground: #f3f1f1 !important;\npadding:10px;\nmax-height:400px;\noverflow-y: scroll;\n}\n.des-box > div > div mat-card.mat-mdc-card.mdc-card.example-card.child-comment{\n  background:#f8f8f8 !important;\n  margin-left:40px;\n  margin-top:10px;\n  mat-card{\n    padding: 10px;\n  }\n}\n@media(max-width:767px){\n  p{\n    flex-wrap: wrap;\n  }\n  .box{\n    // max-height:100vh;\n\n  }\n  .des-box:after{\n    // height:45vh;\n  }\n} \nspan.mdc-list-item__content{\n  text-align: left !important;\n}\nbutton {\n  font-family: \"Raleway\";\n  background-color: #5ea1d8;\n  font-size: 15px;\n  cursor: pointer;\n  color: white;\n  padding: 10px;\n  border-radius: 10px;\n  border: none;\n}\n\n.report-dialog-heading-wrap {\n  margin-left: 20px;\n}\n\n.report-dialog-section-title {\n  color: #212427;\n  font-size: 20px;\n  font-weight: bold;\n  margin-top: -10px;\n  margin-bottom: 4px;\n  text-align: center;\n}\n\n.report-dialog-subtitle {\n  color: #212427;\n  font-size: 14px;\n  margin: 0 0 12px;\n  text-align: left;\n}\n\np.report-dialog-section-title,\np.report-dialog-subtitle {\n  display: block !important;\n  justify-content: unset !important;\n  align-items: unset !important;\n}\n\n.des-box .report-dialog-form#formContent {\n  box-shadow: none !important;\n  border: none !important;\n  background: transparent !important;\n  text-align: left;\n  max-width: none;\n  width: 100%;\n  padding: 0 8px 16px;\n}\n\n.des-box .report-dialog-footer#formFooter {\n  background: transparent !important;\n  border-top: 1px solid #e4e8f0;\n  padding: 16px 0 8px;\n  margin-top: 8px;\n  border-radius: 0;\n}\n\n.report-dialog-submit {\n  width: 120px;\n  font-size: 16px;\n  background-color: #5ea1d8 !important;\n  color: #fff !important;\n}\n\n.report-dialog-submit:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n:host-context(body.theme-dark) {\n  .box,\n  .des-box,\n  .des-box:before,\n  .des-box:after,\n  .report-dialog-form#formContent,\n  .report-dialog-footer#formFooter {\n    background: #111827 !important;\n    color: #e2e8f0 !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  p,\n  h5,\n  span,\n  label,\n  small,\n  .report-dialog-section-title,\n  .report-dialog-subtitle,\n  .close-ico,\n  .close-ico .close-icon {\n    color: #e2e8f0 !important;\n  }\n\n  textarea,\n  input,\n  .in-textarea-wrap textarea {\n    background: #1f2937 !important;\n    color: #f8fafc !important;\n    border-color: rgba(148, 163, 184, 0.45) !important;\n  }\n\n  /* Radio button circles */\n  ::ng-deep .mdc-radio__outer-circle {\n    border-color: #94a3b8 !important;\n  }\n\n  ::ng-deep .mdc-radio--checked .mdc-radio__outer-circle,\n  ::ng-deep .mat-mdc-radio-checked .mdc-radio__outer-circle {\n    border-color: #ffffff !important;\n  }\n\n  ::ng-deep .mdc-radio--checked .mdc-radio__inner-circle,\n  ::ng-deep .mat-mdc-radio-checked .mdc-radio__inner-circle {\n    border-color: #ffffff !important;\n  }\n\n  ::ng-deep .mat-mdc-radio-button .mdc-radio .mdc-radio__native-control:enabled:checked\n    + .mdc-radio__background .mdc-radio__outer-circle {\n    border-color: #ffffff !important;\n  }\n\n  ::ng-deep .mat-mdc-radio-button .mdc-radio .mdc-radio__native-control:enabled:checked\n    + .mdc-radio__background .mdc-radio__inner-circle {\n    border-color: #ffffff !important;\n  }\n\n  ::ng-deep .mat-mdc-radio-button .mdc-radio .mdc-radio__native-control:enabled:not(:checked)\n    + .mdc-radio__background .mdc-radio__outer-circle {\n    border-color: #94a3b8 !important;\n  }\n\n  ::ng-deep .mat-mdc-radio-button .mat-ripple-element {\n    background-color: rgba(255, 255, 255, 0.12) !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
